export default __webpack_public_path__ + "static/mobile_app1-720228ba43b89906e5ad48ac74d7fe85.png";